import { render, staticRenderFns } from "./UserLearningStatusPage.vue?vue&type=template&id=ddfab314&scoped=true"
import script from "./UserLearningStatusPage.vue?vue&type=script&lang=js"
export * from "./UserLearningStatusPage.vue?vue&type=script&lang=js"
import style0 from "./UserLearningStatusPage.vue?vue&type=style&index=0&id=ddfab314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfab314",
  null
  
)

export default component.exports